import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/recursos/caso-fashionable-inc-shopify-plus")({
  beforeLoad: () => {
    throw redirect({ to: "/es/recursos/caso-fashionable-inc-colaboracion", statusCode: 301 });
  },
});
